// extracted by mini-css-extract-plugin
export default {"container":"Questionnaire_container__I927P","icon":"Questionnaire_icon__Z4iNb"};